/** Legacy approval-bin sizes used by diagnostics and the separate capacity-recalculation workflow. */
export const BIN_SIZE_OPTIONS = [15, 20, 30] as const;
export type BinMinutes = (typeof BIN_SIZE_OPTIONS)[number];
export const DEFAULT_BIN_MINUTES: BinMinutes = 20;
